import React from 'react';
import Login from '../Identity/Login';

const Home = () => {
  return (
    <>

      <Login></Login>



    </>

  )
};

export default Home;
